import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PageFrame = ({ children }) => {
    const theme = useTheme();
    const matchDownSm = useMediaQuery(theme.breakpoints.down('md'), { noSsr: false, defaultMatches: false });

    const getFramePadding = () => {
        let padding = '0';
        if (!matchDownSm) {
            padding = '0 24px';
        }

        return padding;
    };

    return (
        <Box
            sx={{
                position: 'relative',
                zIndex: 90,
                overflow: 'hidden',
                padding: 0,
                minHeight: 'calc(100vh - 231px)'
            }}
        >
            {children}
        </Box>
    );
};

export default PageFrame;
